import {
  Communication,
  CustomerDetails,
} from "../../../../../../models/shipments/shipments.tracking";

/**
 * Add empty user communication
 * @param userCommunication {Communication[]} list of user communications
 * @param setFieldError {Function} a function to set an error if necessary
 * @param callback {Function} a function that receives a new empty communication
 */
export const onAddUserCommunication = (
  userCommunication: Communication[],
  setFieldError: () => void,
  callback: (communication: Communication) => void
) => {
  if (userCommunication.length) {
    const fromEmpty = userCommunication.filter((user) => user.userId === 0 || user.from === "");

    if (fromEmpty.length) {
      setFieldError();

      return;
    }
  }

  callback({ userId: 0, from: "" });
};

/**
 * Remove user communication
 * @param userCommunication {Communication[]} list of user communications
 * @param index {number} Index of user communication to be deleted
 * @param callback {Function} a function that receives a list of user communication
 */
export const onRemoveUserCommunication = (
  userCommunication: Communication[],
  index: number,
  callback: (communication: Communication[]) => void
) => {
  if (index === 0 && userCommunication.length <= 1) {
    callback([]);

    return;
  }

  userCommunication.splice(index, 1);

  callback(userCommunication);
};

/**
 * Update customer communication
 * @param customer {CustomerDetails} customer to be added
 * @param customerCommunication {Communication[]} list of customer communication
 * @param communication {Communication} new communication to added
 * @param callback {Function} a function that receives a list of customer communication
 */
export const onUpdatedCustomerCommunication = (
  { customer }: CustomerDetails,
  customerCommunications: Communication[],
  communication: Communication,
  callback: (communication: Communication[]) => void
) => {
  const index: number =
    customerCommunications?.findIndex(
      (communication) => communication.customerId === customer?.id
    ) ?? -1;

  if (Object.values(communication).length) {
    if (index === -1) customerCommunications.push(communication);
    else customerCommunications[index] = communication;
  } else if (index > -1) customerCommunications.splice(index, 1);

  callback(customerCommunications);
};
